import React, { useEffect } from 'react';
import HeroSlider from '../components/HeroSlider';
import SearchBar from '../components/SearchBar';
import { StatsBar, DevelopersStrip } from '../components/StatsAndDevelopers';
import LatestProjects from '../components/LatestProjects';
import TrendingProjects from '../components/TrendingProjects';
import { GuidesSection, AgentsSection } from '../components/GuidesAndAgents';
import { BlogSection, FaqSection, InstagramCta } from '../components/BlogFaqInstagram';

const Home = () => {
  useEffect(() => {
    document.title = 'GOBRA Capital Real Estate | Luxury Property in Dubai \u2013 Buy, Rent & Invest';
  }, []);
  return (
    <main>
      <HeroSlider />
      <SearchBar />
      <StatsBar />
      <DevelopersStrip />
      <LatestProjects />
      <TrendingProjects />
      <GuidesSection />
      <AgentsSection />
      <InstagramCta />
      <BlogSection />
      <FaqSection />
    </main>
  );
};

export default Home;
